import { render, staticRenderFns } from "./Spin.vue?vue&type=template&id=4b50482c&"
import script from "./Spin.vue?vue&type=script&lang=js&"
export * from "./Spin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports